import {
  type ReferentialEnum,
  referentialEnumToReferentialCodeList,
} from "@pharmupp/p3-front-commons"

export const newsStatusesEnum = {
  PUBLISHED: { label: "Publié", color: "success.main" },
  WAITING: { label: "Différé", color: "common.orange" },
  ARCHIVED: { label: "Désactivé", color: "primary.main" },
  DRAFT: { label: "Brouillon", color: "grey.dark" },
  PENDING_REVIEW: { label: "À Vérifier", color: "common.red" },
} as const satisfies ReferentialEnum<{ color: string }>
export const newsStatusesReferential =
  referentialEnumToReferentialCodeList(newsStatusesEnum)
export type NewsStatusesName = keyof typeof newsStatusesEnum

// EVENTS
const newsEventStatusesEnum = {
  ...newsStatusesEnum,
  FINISHED: { label: "Terminé", color: "primary.main" },
  CANCELLED: { label: "Annulé", color: "common.red" },
} as const satisfies ReferentialEnum<{ color: string }>
export const newsEventStatusesReferential =
  referentialEnumToReferentialCodeList(newsEventStatusesEnum)
export type NewsEventStatusesName = keyof typeof newsEventStatusesEnum
